export const TYPE_WX_QQ = {
    1: '微信',
    2: 'QQ',
};
export const ACCOUNT_TYPE = {
    1: '订阅号',
    2: '服务号',
};
export const REPLY_TYPE = {
    article: 3,
    image: 2,
    text: 1,
    posters: 10,
};
export const getMaterialType = (key) => {
    let result = null;
    Object.keys(REPLY_TYPE).forEach((type) => {
        if (REPLY_TYPE[type] === parseInt(key, 10)) {
            result = type;
        }
    });
    return result;
};

/**
 * MessageTypes / ReceiptionMessageTypes 中 text / label / preivewLabel 为中文，
 * 在 i18n 场景下需通过 $t() 取词。
 * 此处保留中文 key 作为 i18n 字典的 key，组件中使用时通过 $t() 包装。
 */
export const MessageTypes = [
    { key: 'article', text: '图文消息', background: '#F1F6FF',
        border: '1px solid #DBE8FF', label: '选择图文消息',
        icon: 'basic_picture_text_fill', iconColor: '#6E92FF',
        preivewLabel: '图文消息预览',
    },
    { key: 'image', text: '图片消息', background: '#E6F8EF',
        border: '1px solid #C0EBD7', label: '选择图片消息',
        icon: 'basic_picture_line', iconColor: '#34C48F',
        preivewLabel: '图片消息预览',
    },
    { key: 'text', text: '文本消息', background: '#ECEEF1',
        border: '1px solid #E0E2E7', label: '选择文本消息',
        icon: 'basic_papers_line', iconColor: '##777C8D',
        preivewLabel: '文本消息预览',
    }];

export const ReceiptionMessageTypes = MessageTypes.map((type) => {
    const ret = Object.assign({}, type);
    if (ret.key === 'article') {
        ret.icon = 'basic_picture_text_line';
    }
    return ret;
});
